import React, { FunctionComponent, ReactNode } from 'react';
import styles from './PageSummary.scss';
import classNames from 'classnames';

type PageSummaryProps = {
  image?: ReactNode;
  pagetitle: ReactNode;
  pagesubtitle: ReactNode;
  ctas: ReactNode;
};

const PageSummary: FunctionComponent<PageSummaryProps> = ({
  pagetitle,
  pagesubtitle,
  image,
  ctas,
}) => {
  return (
    <section className={styles.pageSummary} data-qa="page-summary">
      <div
        className={classNames(
          'container',
          'jg-space-phmd',
          'jg-space-phml@xl',
          'jg-space-pvsm',
          styles.container,
        )}
      >
        {image && (
          <div className={styles.image} data-qa="page-summary-image">
            {image}
          </div>
        )}
        <div
          className={classNames(
            'jg-display-n@xs',
            'jg-display-b@lg',
            styles.content,
          )}
        >
          <h1 data-qa="page-summary-title" className="jg-h6 jg-space-mbn">
            {pagetitle}
          </h1>
          <div data-qa="page-summary-subtitle">{pagesubtitle}</div>
        </div>
        <div data-qa="page-summary-ctas" className={styles.cta}>
          {ctas}
        </div>
      </div>
    </section>
  );
};

export default PageSummary;
